module.exports = __webpack_public_path__ + "img/banner.5532e8e1.jpg";